<template>
  <v-dialog v-model="dialog" :width="width" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dense flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4">{{ message }}</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="darken-1" text @click.native="agree">Ja</v-btn>
        <v-btn color="grey" text @click.native="cancel">Nein</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  data: () => ({
    dialog: false,
    resolve: null,
    width: 275,
    reject: null,
    message: null,
    title: null
  }),
  methods: {
    open(title, message, width) {
      this.title = title;
      this.message = message;
      this.width = width;
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      })
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
}
</script>

<style scoped>

</style>